export const SYSTEM_MAINTAIN_PLACEHOLDER = `例）平素は、AIMO Parkingをご利用いただき、誠にありがとうございます。 下記の日程においてシステムメンテナンスを実施いたします。

メンテナンス期間中はサービスが一時的に正しく利用できない場合がございますので、ご了承ください。

【メンテナンス期間】 0000年00月00日（○曜日）00:00～00:00まで

※メンテナンス時間については前後する場合がございます。予めご了承ください。 ご迷惑をおかけいたしますが、ご理解いただきますようお願いいたします。`;
